<template>
  <div class="footer-menu">
    <div class="container-xl">
      <div class="footer-menu-inner">
        <div class="footer-top">
          <public-link to="/" class="footer-brand">
            <img class="footer-brand-logo" alt="Lendly" src="@/assets/img/footer-logo.png">
          </public-link>
          <img class="footer-wordmark" alt="Lendly" src="@/assets/img/footer-company-name.png">
        </div>

        <hr class="footer-divider">

        <div class="footer-middle">
          <address class="footer-contacts">
            <div class="footer-socials">
              <a
                  v-for="social in socials"
                  :key="social.name"
                  :href="social.href"
                  target="_blank"
                  rel="noopener"
                  class="footer-social"
              >
                <img :src="social.icon" :alt="social.name">
              </a>
            </div>
            <p class="footer-company">ООО "Лендли" &nbsp;ИНН: 7814733360</p>
            <p class="footer-company">&copy; 2020 - {{ year }} ООО "Лендли"</p>
            <p class="footer-company">
              <a href="mailto:support@lendly.ru">support@lendly.ru</a>
              <a href="https://t.me/lendlysupport" target="_blank" rel="noopener" class="ml-3">@lendlysupport</a>
            </p>
          </address>

          <ul class="footer-links">
            <li v-for="link in links" :key="link.label">
              <public-link :to="link.to" class="footer-link">
                {{ link.label }}
                <svg class="footer-arrow" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M11.1238 6.33325L6.55991 1.76932L7.97412 0.355104L14.2542 6.63513V8.04935L7.99224 14.3113L6.57802 12.897L11.1418 8.33325L0.642457 8.33325L0.642457 6.33325L11.1238 6.33325Z"/>
                </svg>
              </public-link>
            </li>
          </ul>
        </div>

        <hr class="footer-divider">

        <div class="footer-bottom">
          <address class="footer-address">
            197374, Г. САНКТ-ПЕТЕРБУРГ, ВН. ТЕР. Г. МУНИЦИПАЛЬНЫЙ ОКРУГ № 65,
            УЛ САВУШКИНА, Д. 126 ЛИТЕРА А, ПОМЕЩ. 112НС
          </address>
          <a href="#" class="footer-to-top" @click.prevent="scrollToTop">
            Наверх
            <svg class="footer-arrow footer-arrow--up" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.1238 6.33325L6.55991 1.76932L7.97412 0.355104L14.2542 6.63513V8.04935L7.99224 14.3113L6.57802 12.897L11.1418 8.33325L0.642457 8.33325L0.642457 6.33325L11.1238 6.33325Z"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PublicLink from "@/components/common/components/PublicLink.vue";

export default {
  name: "FooterMenu",
  components: {
    PublicLink
  },
  data() {
    return {
      year: new Date().getFullYear(),
      socials: [
        { name: "Telegram", href: "https://t.me/lendly", icon: require("@/assets/img/footer-telegram.svg") },
        { name: "VK", href: "https://vk.com/lendlyru", icon: require("@/assets/img/footer-vk.svg") },
        { name: "YouTube", href: "https://www.youtube.com/@LENDLYNEWS", icon: require("@/assets/img/footer-youtube.svg") },
        { name: "MAX", href: "https://max.ru/id7814733360_biz", icon: require("@/assets/img/footer-max.svg") },
      ],
      links: [
        { label: "Раскрытие информации", to: "/page/raskrytie-informatsii" },
        { label: "Актуальные документы", to: "/page/aktualnye-dokumenty" },
        { label: "Архив документов", to: "/page/arkhiv-dokumentov" },
        { label: "О платформе", to: "/page/aboutus" },
        { label: "FAQ", to: "/faq" },
      ],
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
}
</script>

<style lang="scss">
.footer-menu {
  background:
    url("~@/assets/img/footer-noise.webp") center repeat,
    url("~@/assets/img/footer-background.webp") no-repeat center bottom,
    var(--bg-green-color);
  color: var(--white-color);
  padding: 2rem 3rem;

  a {
    color: var(--white-color);
  }

  .footer-menu-inner {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .footer-divider {
    border: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.6);
    margin: 0;
  }

  .footer-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .footer-brand-logo {
    height: 2.25rem;
    width: auto;
    display: block;
  }

  .footer-wordmark {
    height: 3rem;
    width: auto;
    display: block;
  }

  .footer-middle {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    flex-wrap: wrap;
  }

  .footer-contacts {
    font-style: normal;
    font-size: 0.85rem;
    margin: 0;

    .footer-company {
      margin: 0 0 0.25rem;
    }
  }

  .footer-socials {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.75rem;

    .footer-social img {
      height: 2rem;
      width: 2rem;
      display: block;
    }
  }

  .footer-links {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: right;

    li {
      margin: 0;
    }
  }

  .footer-link {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.35rem 0;
    text-decoration: underline;
    font-size: 0.9rem;

    &:hover {
      text-decoration: none;
    }
  }

  .footer-arrow {
    width: 0.8rem;
    height: 0.8rem;
    fill: var(--white-color);
    flex: 0 0 auto;

    &--up {
      transform: rotate(-90deg);
    }
  }

  .footer-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .footer-address {
    font-style: normal;
    font-size: 0.8rem;
    margin: 0;
    max-width: 40rem;
  }

  .footer-to-top {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.9rem;
    white-space: nowrap;
    text-decoration: none;
  }

  @media (max-width: 991px) {
    padding: 1.5rem;

    .footer-wordmark {
      height: 2.25rem;
    }

    .footer-middle {
      flex-direction: column;
      gap: 1.25rem;
    }

    .footer-links {
      text-align: left;
    }

    .footer-bottom {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
